import React from 'react';
import { convertDateLawVersion } from './legislationSnippetUtils';
import styles from './legislation_selector.module.scss';
import { StateType } from '../../../../../state/state.types';

type Props = {
  lawOtherVersions: NonNullable<
    StateType['results']['snippets']['law']
  >['otherVersions'];
  onSelect: (event: React.ChangeEvent<HTMLSelectElement>) => void;
  selected?: string;
};

export function LegislationSelector({
  lawOtherVersions,
  onSelect,
  selected,
}: Props) {
  return (
    <select className={styles.select} value={selected} onChange={onSelect}>
      {lawOtherVersions.map(version => (
        <option
          aria-label={version.articleId}
          key={version.articleId}
          value={version.articleId}
          dangerouslySetInnerHTML={{
            __html: convertDateLawVersion({
              start: version.startingDateHtml,
              end: version.endingDateHtml,
            }),
          }}
        />
      ))}
    </select>
  );
}
